import { render } from "./ModalAsociaMenu.vue?vue&type=template&id=1fd2907e&scoped=true"
import script from "./ModalAsociaMenu.vue?vue&type=script&lang=js"
export * from "./ModalAsociaMenu.vue?vue&type=script&lang=js"

import "./ModalAsociaMenu.vue?vue&type=style&index=0&id=1fd2907e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd2907e"]])

export default __exports__